// extracted by mini-css-extract-plugin
export var actionIcon = "_v3-0";